import { observable, action, computed } from "mobx"
import { fixProgress } from "../tools/uploadTools"
import { EXCEPTION, INACTIVE, ACTIVE, SUCCESS } from "./File"
import { TASK_TYPE } from "./TaskModel"
import request from "app/vendor/request"
import config from "app/config"
import { message } from 'antd'

export default class {
  type = TASK_TYPE.group
  @observable groupInfo = {}
  @observable files = []
  @observable judgeData = {}

  constructor (groupInfo) {
    this.groupInfo = groupInfo
    this.name = groupInfo.name
  }

  get referenceCount () {
    return this.files.filter(file => file.reference).length
  }

  @computed get judgeDataReady () {
    return Object.keys(this.judgeData).length > 0
  }

  @computed get size () {
    return this.files.length
  }

  @computed get children () {
    return this.files
  }

  @computed get progress () { // 100 / chunkCount --->chunkPercent
    let progress = this.files.reduce(
      (sum, file) => sum + file.progress * (file.chunkCount / this.chunkCount),
    0)
    return fixProgress(progress)
  }

  @computed get status () {
    if (this.files[0].isInactived) {
      return INACTIVE
    }

    let successCount = 0, groupSize = this.files.length

    for (let i = 0; i < groupSize; i++) {
      if (this.files[i].isActived) { // 激活状态（存在上传中的任务）
        return ACTIVE
      } else if (this.files[i].isSuccess) {
        successCount ++
      }
    }
    return successCount === groupSize ? SUCCESS : EXCEPTION // 执行本行代码说明在已经开始上传的情况下组内不存在正在上传中的文件，说明已经全部处理完毕
  }

  @computed get statusText () {
    if (this.isInactived) {
      return '当前分组上传未开始'
    } else if (this.isError) {
      return '当前分组存在异常文件'
    } else if (this.isActived) {
      return '当前分组有文件正在上传中'
    } else {
      return '当前分组已全部上传成功'
    }
  }

  @computed get isError () {
    return this.status === EXCEPTION
  }

  @computed get isSuccess () {
    return this.status === SUCCESS
  }

  @computed get isActived () {
    return this.status === ACTIVE
  }

  @computed get isInactived () {
    return this.status === INACTIVE
  }

  @computed get chunkCount () {
    return this.files.reduce(
      (sum, file) => sum + file.chunkCount,
    0)
  }

  @computed get successCount () {
    return this.files.reduce((sum, file) => file.isSuccess ? sum + 1 : sum, 0)
  }

  @computed get failedData () {
    const result = {
      groupInfo: this.groupInfo,
      count: this.files.length - this.successCount,
      files: []
    }
    // this.files.forEach(file => {
    //   if (file.isError) {
    //     result.count ++
    //     result.files.push(file)
    //   }
    // })
    return result
  }

  @computed get unReachable () { // 小组执行失败且上传成功任务 > 0 时不可操作
    return this.isActived || this.successCount > 0
  }

  @action push = (file) => {
    file.groupInfo = this.groupInfo
    this.files.push(file)
  }

  @action add = (file) => {
    file.groupInfo = this.groupInfo
    this.files.unshift(file)
  }

  @action remove = (file) => {
    const index = this.files.indexOf(file)
    this.files.splice(index, 1)
  }

  @action clear = () => {
    this.files = []
  }

  @action sort = (callback) => {
    this.files.sort(callback)
  }

  @action switchReference = (file) => {
    file.reference = !file.reference

    // if (file.reference && this.selectedFile && this.selectedFile !== file) {
    //   this.selectedFile.reference = false
    // }
    // this.selectedFile = file
  }

  @action getJudgeData = () => {
    if (this.judgeDataReady) {
      return
    }
    return request.get(`${config.backend}/pgd/family/${this.groupInfo.id}/samples`)
      .checkToken()
      .commonDispose()
      .then(
      res => {
        this.judgeData = res
        return Promise.resolve(res)
      },
      err => {
        message.error(err)
        return Promise.reject(err)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/stores/Group.js